import React from "react";
import SettingsSection from "../SettingsSection";
import ChannelPicker from "../ChannelPicker";
import RolePicker from "../RolePicker";

export default function PartnershipSection({
  channels,
  roles,
  partnershipConfig,
  setPartnershipConfig,
  partnershipBlacklist,
  setPartnershipBlacklist,
  newBlacklistId,
  setNewBlacklistId,
}) {
  const update = (field, value) => {
    setPartnershipConfig({ ...partnershipConfig, [field]: value });
  };

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Configure partnership posting and logging. Add/remove partners via{" "}
        <code>/partner</code> in Discord.
      </p>

      <label className="input-label">PARTNERSHIP CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={partnershipConfig.channelId || ""}
        onChange={(v) => update("channelId", v)}
        types={[0]}
      />

      <label className="input-label">PARTNERSHIP LOG CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={partnershipConfig.logChannelId || ""}
        onChange={(v) => update("logChannelId", v)}
        types={[0]}
      />

      <label className="input-label">PARTNER MANAGER ROLE</label>
      <RolePicker
        roles={roles}
        value={partnershipConfig.partnerRole || ""}
        onChange={(v) => update("partnerRole", v)}
        emptyLabel="None"
        placeholder="Select partner manager role…"
      />
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Optional role required to use partnership commands.
      </p>

      <label className="input-label">PING ROLE ON NEW PARTNERSHIP</label>
      <RolePicker
        roles={roles}
        value={partnershipConfig.pingRoleId || ""}
        onChange={(v) => update("pingRoleId", v)}
        emptyLabel="None"
        placeholder="Select ping role…"
      />
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        When a partnership ad is posted, this role is mentioned in the
        partnership channel.
      </p>

      <label className="input-label">EMBED COLOR</label>
      <input
        type="color"
        value={partnershipConfig.embedColor || "#4a0e17"}
        onChange={(e) => update("embedColor", e.target.value)}
        className="settings-input"
      />

      <label className="input-label">DEFAULT AD TEXT</label>
      <textarea
        className="settings-input large-text"
        value={partnershipConfig.defaultAd || ""}
        onChange={(e) => update("defaultAd", e.target.value)}
        placeholder="Your server's partnership advertisement..."
        style={{ minHeight: "80px" }}
      />

      <label className="input-label">COOLDOWN (HOURS)</label>
      <input
        type="number"
        min="1"
        className="settings-input"
        value={partnershipConfig.cooldownHours ?? 24}
        onChange={(e) =>
          update("cooldownHours", parseInt(e.target.value) || 24)
        }
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        BLACKLISTED SERVER IDS
      </label>
      <div className="word-input-group" style={{ marginBottom: "10px" }}>
        <input
          type="text"
          className="settings-input"
          style={{ marginBottom: 0 }}
          value={newBlacklistId}
          onChange={(e) => setNewBlacklistId(e.target.value)}
          placeholder="Server ID..."
        />
        <button
          type="button"
          className="manage-btn"
          style={{ width: "80px", marginTop: 0, height: "54px" }}
          onClick={() => {
            const id = newBlacklistId.trim();
            if (id && !partnershipBlacklist.includes(id)) {
              setPartnershipBlacklist([...partnershipBlacklist, id]);
              setNewBlacklistId("");
            }
          }}
        >
          ADD
        </button>
      </div>
      <div className="word-tags">
        {partnershipBlacklist.map((id) => (
          <span key={id} className="word-tag">
            {id}
            <button
              type="button"
              onClick={() =>
                setPartnershipBlacklist(
                  partnershipBlacklist.filter((x) => x !== id),
                )
              }
            >
              ×
            </button>
          </span>
        ))}
      </div>
    </SettingsSection>
  );
}
